<template>
    <div class="ls-pricing-unavailable__container">
        <form @submit.prevent="submitPricingUnavailableForm()">
            <ls-panel
                class="ls-border-all ls-border-bottom-none ls-pricing-unavailable__service-details"
            >
                <ls-manual-request>
                    <h2
                        class="ls-align--center ls-condensed section-title"
                        :class="{ 'ls-margin--bottom': screenSize.xs }"
                    >
                        Whoops! We couldn't get you an automatic quote :(
                    </h2>
                    <p class="ls-align--center" data-font-size="-1" style="margin-top: 3px;">
                        No need to worry. Fill out the form below, and we'll be in touch ASAP.
                    </p>
                    <hr />
                </ls-manual-request>
            </ls-panel>
            <ls-panel class="ls-border-all ls-border-top-none ls-pricing-unavailable__contact-form">
                <ls-contact-info :title="'How can we get in touch with you?'"></ls-contact-info>
                <ls-error></ls-error>

                <div slot="button" class="grid">
                    <div class="grid__col-12 ls-margin--top">
                        <button
                            v-ls-track.click="{
                                target: 'pricing-unavailable-form--submit-button',
                            }"
                            :class="{
                                'ls-button ls-button--block ls-button--lg ls-margin--top': true,
                                'll-button-primary': isLawnLove || isHomeGnome,
                                'ls-button--yellow': isLawnStarter,
                            }"
                            type="submit"
                        >
                            <span v-if="manualRequest.submitting"
                                ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Requesting Quote</span
                            >
                            <span v-else>Request Quote</span>
                        </button>
                    </div>
                </div>
            </ls-panel>
        </form>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import * as types from '@/store/types';
import { mapState, mapActions, mapGetters } from 'vuex';
import eventBusService from '@/services/event-bus.service';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import lsManualRequest from '@/components/original-mydot/manual-request/ManualRequest.vue';
import lsContactInfo from '@/components/original-mydot/contact-info/ContactInfo.vue';
import lsError from '@/components/original-mydot/error/Error.vue';
import brandMixin from '@/mixins/brand.mixin';

export default {
    components: {
        lsPanel,
        lsManualRequest,
        lsContactInfo,
        lsError,
    },
    mixins: [brandMixin],
    computed: {
        ...mapState(['manualRequest', 'contactInfo', 'screenSize']),
        ...mapGetters({
            desktop: types.SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
        allStatesValid() {
            return this.manualRequest.valid && this.contactInfo.valid;
        },
    },
    methods: {
        ...mapActions({
            submitManualRequest: types.MANUAL_REQUEST__SUBMIT_MANUAL_REQUEST,
        }),
        submitPricingUnavailableForm() {
            if (!this.allStatesValid) {
                eventBusService.eventBus.$emit('submitButtonClick');
                setTimeout(() => {
                    const firstInvalidInput =
                        document.getElementsByClassName('ls-manual-request--mq-invalid')[0] ||
                        document.getElementsByClassName('ls-invalid')[0] ||
                        null;
                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
            } else {
                this.submitManualRequest(this.$route);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-pricing-unavailable__container {
    margin-bottom: 100px; // scrolling to make bottom not feel like its getting cut off
}

.themed-lawnlove {
    .ls-pricing-unavailable__service-details {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
    }

    .ls-pricing-unavailable__contact-form {
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
    }
}
</style>
